module.exports = __webpack_public_path__ + "img/image127.eca9455b.png";